import { Handyman, SupportAgent } from '@lichtblick/icons';

import { Container } from './ChatAvatar.styles';

type ChatAvatarProps = {
  isCraftsman: boolean;
};

export const ChatAvatar = ({ isCraftsman }: ChatAvatarProps) => (
  <Container $isCraftsman={isCraftsman} data-testid="chat-avatar">
    {isCraftsman ? <Handyman data-testid="svg-handyman" /> : <SupportAgent data-testid="svg-support-agent" />}
  </Container>
);
